import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchMonthBasedRegistrationData = async (type: string) => {
  const response = await queryExecute({
    query: graphql(`
      query MonthBasedRegistrationData($type: String!) {
        monthBasedRegistrationData(type: $type) {
          month
          type
          count
          numOfMonths
          category
        }
      }
    `),
    variables: {
      type,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.monthBasedRegistrationData;
};
